import CarePlanIcd10Code from './CarePlanIcd10Code';

export default CarePlanIcd10Code;
